<template>
  <div id="core-toolbar-actions">
    <!-- userIsLogged: {{ userIsLogged }} -->
    <div v-if="$vuetify.breakpoint.xsOnly">
      <v-menu left bottom open-on-hover close-on-content-click>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item v-if="actionsShow.dashboard">
            <sl-btn-to-dashboard color="secondary"></sl-btn-to-dashboard>
          </v-list-item>
          <v-list-item v-show="actionsShow.account">
            <v-btn icon color="secondary" to="/account">
              <!-- <sl-avatar :user="userLogged" /> -->
              <v-icon>mdi-account</v-icon>
            </v-btn>
          </v-list-item>
          <v-list-item v-show="actionsShow.settings">
            <v-btn icon color="secondary" to="/settings">
              <v-icon>mdi-cog</v-icon>
            </v-btn>
          </v-list-item>
          <!------------------------##-- SlBtnToSupport.vue --##------------------------->
          <v-list-item v-show="actionsShow.help">
            <sl-btn-support color="secondary" />
          </v-list-item>
          <v-list-item v-show="actionsShow.registration">
            <v-btn outlined color="secondary" to="/registration">Register</v-btn>
          </v-list-item>
          <v-list-item v-show="actionsShow.login">
            <v-btn outlined color="secondary" to="/login">Login</v-btn>
          </v-list-item>
          <v-list-item v-show="actionsShow.logout">
            <v-btn icon color="secondary" @click="onLogout">
              <v-icon>mdi-logout</v-icon>
            </v-btn>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
    <div v-else>
      <!------------------------##-- SlBtnToDashboard.vue --##------------------------->
      <sl-btn-to-dashboard
        v-if="actionsShow.dashboard"
        key="action-dashboard"
        color="secondary"
      ></sl-btn-to-dashboard>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-show="actionsShow.account"
            key="action-account"
            icon
            color="secondary"
            to="/account"
            v-bind="attrs"
            v-on="on"
          >
            <!-- <sl-avatar :user="userLogged" /> -->
            <v-icon>mdi-account</v-icon>
          </v-btn>
        </template>
        <span>User account</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-show="actionsShow.settings"
            key="action-settings"
            icon
            color="secondary"
            to="/settings"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon>mdi-cog</v-icon>
          </v-btn>
        </template>
        <span>Workspace configuration</span>
      </v-tooltip>

      <!------------------------##-- SlBtnToSupport.vue --##------------------------->
      <sl-btn-support v-show="actionsShow.help" color="secondary" />

      <v-btn
        v-show="actionsShow.registration"
        key="action-registration"
        outlined
        color="secondary"
        class="mx-1"
        to="/registration"
      >
        Register
      </v-btn>

      <v-btn
        v-show="actionsShow.login"
        key="action-login"
        outlined
        color="secondary"
        class="mx-1"
        to="/login"
      >
        Login
      </v-btn>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-show="actionsShow.logout"
            key="action-logout"
            icon
            color="secondary"
            @click="onLogout"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon>mdi-logout</v-icon>
          </v-btn></template
        >
        <span>Logout</span>
      </v-tooltip>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

import User from '@/models/User'

import SlBtnSupport from '@/components/SlBtnSupport'
import SlBtnToDashboard from '@/components/SlBtnToDashboard'

// import { DEVICE_USER_QUERY } from '../../constants/graphql'

// import { AH_CONSTANTS } from '../../constants/gui'

// const today = new Date()
// const time = `${today.getHours().toString().padStart(2, '0')}:${today.getMinutes().toString().padStart(2, '0')}`

export default {
  components: {
    SlBtnSupport,
    SlBtnToDashboard,
  },

  data: () => ({
    /* user: {
      id: null,
      firstName: '',
      lastName: ''
    } */
    //
  }),

  computed: {
    actionsShow: function() {
      return {
        dashboard: this.userIsLogged,
        account: this.userIsLogged,
        help: true,
        login: this.$route.name != 'Login' && !this.userIsLogged,
        registration: this.$route.name != 'Registration' && !this.userIsLogged,
        settings: this.userIsLogged,
        logout: this.userIsLogged,
      }
      // return {
      //   account: this.$route.name != 'Account' && this.userIsLogged,
      //   help: this.$route.name != 'Help',
      //   login: this.$route.name != 'Login' && !this.userIsLogged,
      //   registration: this.$route.name != 'Registration' && !this.userIsLogged,
      //   settings: this.$route.name != 'Settings' && this.userIsLogged,
      //   logout: this.userIsLogged,
      // }
    },
    ...mapState({
      // userLogged: state => state.userLogged,
      userIsLogged: state => state.userLogged.logged,
      // workspaceIdCurrent: state => state.nodeCurrent.workspace.id,
    }),
  },

  watch: {
    //
  },

  /* created() {
    this.queries = [
      User.find({
        get: '{ id, firstName, lastName, mailinglistAccepted }',
        by: { id: this.userLogged.id },
        onChange: data => {
          this.user = data
        },
      }),
    ]
  }, */

  mounted() {
    //
    // Logger.debug(this.actions)
  },

  /* beforeDestroy() {
    this.queries.forEach(q => q.destroy())
  }, */

  methods: {
    onLogout() {
      User.doLogout()
      this.userLoggedOut() // FIXME: spostare in User
      this.$router.push({ name: 'Login' })
    },
    ...mapMutations([
      'userLoggedOut', // FIXME: sposrtare in User
      'toastSet',
    ]),
  },
}
</script>
